import styled from 'styled-components';

export const Overlay = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
  background-color: #fafbfd;
`;

export const Container = styled.div`
  display: flex;
  padding: 24px;
  width: 100%;
  max-width: 379px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 6px 10px rgba(33, 39, 73, 0.12);
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.div`
  color: #161a30;
  font-size: 18px;
  font-weight: 600;
  flex: 1;

  margin-bottom: 8px;
`;

export const Logo = styled.img`
  width: 80px;
  height: 16px;
`;

export const Divider = styled.div`
  height: 32px;
`;

export const Alert = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
  margin-bottom: 24px;
`;

export const Description = styled.div`
  color: #474d66;
  font-size: 14px;
  font-weight: 400;
  text-align: center;

  margin-bottom: 40px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
